import { stripeClient } from "@better-auth/stripe/client";
import {
	customSessionClient,
	inferAdditionalFields,
	organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "@/lib/auth"; // Import the auth instance as a type
import { AUTH_SITE_URL } from "./utils";

export const authClient = createAuthClient({
	baseURL: AUTH_SITE_URL, // the base url of your auth server
	plugins: [
		inferAdditionalFields<typeof auth>(),
		organizationClient(),
		customSessionClient<typeof auth>(),
		stripeClient({
			subscription: true,
		}),
	],
});

export const { signIn, signOut, signUp, useSession } = authClient;
